module.exports = __webpack_public_path__ + "static/img/pay_remind_pic@3x.d6dd906.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay_remind_pic@3x.png
// module id = Ci6M
// module chunks = 1